<script>
import {defineComponent} from 'vue'
import SmsPatternPicker from "@/view/components/pickers/smsPatternPicker.vue";
import PatternInputsGenerate from "@/view/components/fragments/patternInputsGenerate.vue";
import BannerSelector from "@/view/components/UploadCenter/bannerSelector.vue";

export default defineComponent({
  name: "Notified",
  components: {BannerSelector, PatternInputsGenerate, SmsPatternPicker},
  data () {
    return{
      tabs: 0,
    }
  }
})
</script>

<template>
  <custom-tabs v-model="tabs" grow>
    <template v-slot:staticTabs>
      <v-tab :ripple="false">
        <div class="cornel-left"></div>
        <div class="cornel-right"></div>
        <div
            class="d-flex row"
            style="
                    justify-content: center !important;
                    align-items: center;
                  "
        >
          پیامک
          <help-info
              :element-name="`${serviceName}-${componentName}-added`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              :label="$t('feedbacks')"
          />
        </div>
      </v-tab>

      <v-tab :ripple="false">
        <div class="cornel-left"></div>
        <div class="cornel-right"></div>
        <div
            class="d-flex row"
            style="
                    justify-content: center !important;
                    align-items: center;
                  "
        >
          واتساپ
          <help-info
              :element-name="`${serviceName}-${componentName}-added`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              :label="$t('add')"
          />
        </div>
      </v-tab>

    </template>

    <template v-slot:middle>
      <div class="py-2"></div>
    </template>

    <template v-slot:staticItems >

      <v-tab-item >
        <!--  v-model="computedConfigs.isActive"-->
        <v-switch
            :hint="$t('welcome_message_hint')"
            :label="$t('send_sms')"
            persistent-hint
        />

        <SmsPatternPicker/>

        <pattern-inputs-generate/>

      </v-tab-item>

      <v-tab-item>
        <v-switch
            hint="با فعال کردن این گزینه کاربران میتواند با شماره تلفنی که شما تعریف میکنید فیش واریزی خود را ارسال نمایید"
            label="واتساپ"
            persistent-hint
        />
        <div class="row mt-2">
          <div class="col-6">
            <v-text-field
                append-icon="mdi-pen"
                class="mt-0 pt-0 contentinfo"
                clear-icon="mdi-close-circle-outline"
                clearable
                dense
                label="شماره تلفن"
                outlined
            />
          </div>
          <div class="col-6">
            <v-text-field
                append-icon="mdi-pen"
                class="mt-0 pt-0 contentinfo"
                clear-icon="mdi-close-circle-outline"
                clearable
                dense
                label="هزینه ارسال"
                outlined
            />
          </div>
        </div>
      </v-tab-item>


    </template>
  </custom-tabs>

</template>

<style scoped>

</style>